import styles from './suggestionsList.module.scss';

const SuggestionsListComponent = ({ onClick, filteredSuggestions }) => (
  <ul className={styles.suggestionsContainer}>
    {filteredSuggestions.length >= 1
      ? filteredSuggestions.map(suggestion => (
          <li className={styles.suggestion} key={suggestion.place_id} onClick={onClick}>
            {suggestion.description}
          </li>
        ))
      : null}
  </ul>
);

export default SuggestionsListComponent;
